/* eslint-disable */

/*
 * Copyright 2010-2016 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

import utils from '../apiGatewayCore/utils';
import { apiGatewayClientFactory } from '../apiGatewayCore/apiGatewayClient.js'
import uritemplate from "../apiGatewayCore/url-template"

const accountLockClientFactory = {};
accountLockClientFactory.newClient = function (config, invokeUrl) {
    var apigClient = { };
    if(config === undefined) {
        config = {
            accessKey: '',
            secretKey: '',
            sessionToken: '',
            region: '',
            apiKey: undefined,
            defaultContentType: 'application/json',
            defaultAcceptType: 'application/json'
        };
    }
    if(config.accessKey === undefined) {
        config.accessKey = '';
    }
    if(config.secretKey === undefined) {
        config.secretKey = '';
    }
    if(config.apiKey === undefined) {
        config.apiKey = '';
    }
    if(config.sessionToken === undefined) {
        config.sessionToken = '';
    }
    if(config.region === undefined) {
        config.region = 'us-east-1';
    }
    //If defaultContentType is not defined then default to application/json
    if(config.defaultContentType === undefined) {
        config.defaultContentType = 'application/json';
    }
    //If defaultAcceptType is not defined then default to application/json
    if(config.defaultAcceptType === undefined) {
        config.defaultAcceptType = 'application/json';
    }


    // extract endpoint and path from url
    var endpoint = /(^https?:\/\/[^\/]+)/g.exec(invokeUrl)[1];
    var pathComponent = invokeUrl.substring(endpoint.length);

    var sigV4ClientConfig = {
        accessKey: config.accessKey,
        secretKey: config.secretKey,
        sessionToken: config.sessionToken,
        serviceName: 'execute-api',
        region: config.region,
        endpoint: endpoint,
        defaultContentType: config.defaultContentType,
        defaultAcceptType: config.defaultAcceptType
    };

    var authType = 'NONE';
    if (sigV4ClientConfig.accessKey !== undefined && sigV4ClientConfig.accessKey !== '' && sigV4ClientConfig.secretKey !== undefined && sigV4ClientConfig.secretKey !== '') {
        authType = 'AWS_IAM';
    }

    var simpleHttpClientConfig = {
        endpoint: endpoint,
        defaultContentType: config.defaultContentType,
        defaultAcceptType: config.defaultAcceptType
    };

    var apiGatewayClient = apiGatewayClientFactory.newClient(simpleHttpClientConfig, sigV4ClientConfig);



    apigClient.lockPost = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['body', 'deviceUUID'], ['body']);

        var lockPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/lock').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, ['deviceUUID']),
            body: body
        };


        return apiGatewayClient.makeRequest(lockPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.lockOptions = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var lockOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/lock').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(lockOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.unlockPost = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['body', 'deviceUUID'], ['body']);

        var unlockPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/unlock').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, ['deviceUUID']),
            body: body
        };


        return apiGatewayClient.makeRequest(unlockPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.unlockOptions = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var unlockOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/unlock').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(unlockOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.unlockRequestPost = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['deviceUUID'], ['body']);

        var unlockRequestPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/unlockRequest').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, ['deviceUUID']),
            body: body
        };


        return apiGatewayClient.makeRequest(unlockRequestPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.unlockRequestOptions = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var unlockRequestOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/unlockRequest').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(unlockRequestOptionsRequest, authType, additionalParams, config.apiKey);
    };


    return apigClient;
};



export default accountLockClientFactory
